import { useEffect, useState } from 'react'
import { call } from '../Methods.js'

function Dashboard () {
  const pageTitle = 'Əsas'
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`

  const getData = async () => {
    setLoading(() => true)
    let data = await call.forLoggedUser.dashboard.getDashboardInfo({})
    if (data.success) {
      setData(data.data)
    }
    setLoading(() => false)
  }

  useEffect(() => {
    getData()
  }, [])

  const dashboardInfoSettings = {
    sections: [
      {
        title: 'Statistik məlumatlar',
        name: 'shortStats',
        contentType: 'boxes',
        defaultOpen:true,
        fields: [
          {
            icon: 'Images/Icons/menu-icons/request.svg',
            title: 'Yeni müraciətlər',
            property: 'NewRequestCount'
          },
          {
            icon: 'Images/Icons/menu-icons/student.svg',
            title: 'Aktiv iştirakçılar',
            property: 'ActiveStudentCount'
          },
          {
            icon: 'Images/Icons/menu-icons/group.svg',
            title: 'Aktiv qruplar',
            property: 'ActiveGroupCount'
          },
          {
            icon: 'Images/Icons/menu-icons/teacher.svg',
            title: 'Aktiv müəllimlər',
            property: 'ActiveTeacherCount'
          }
        ]
      },
      {
        title: 'Doğum günləri',
        name: 'birthdays',
        contentType: 'labels',
        icon: 'Images/Icons/dashboard-icons/bcake.svg',
        defaultOpen:true,
      },
      {
        title: 'Maliyyə statistikası',
        name: 'finStats',
        contentType: 'boxes',
        defaultOpen:false,
        fields: [
          {
            icon: 'Images/Icons/menu-icons/payment.svg',
            title: 'Gecikən ödənişlər',
            property: '1'
          },
          {
            icon: 'Images/Icons/menu-icons/payment.svg',
            title: 'Son ödəniş',
            property: '2'
          },
          {
            icon: 'Images/Icons/menu-icons/payment.svg',
            title: 'Gözlənilən xərclər',
            property: '3'
          },
          {
            icon: 'Images/Icons/menu-icons/payment.svg',
            title: '-',
            property: '4'
          }
        ]
      }
    ]
  }

  return (
    !loading &&
    data && (
      <div className='dashboard-page page'>
        {dashboardInfoSettings.sections.map(s => {
          return (
            <DashboardSection
              key={s.name}
              settings={s}
              sectionData={data?.[s.name]}
            />
          )
        })}
      </div>
    )
  )
}

function DashboardSection ({ settings, sectionData }) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    console.log(sectionData)
    setData(sectionData)
  }, [sectionData])

  useEffect(()=>{
    setOpen(settings.defaultOpen)
  },[])

  return (
    <div className={`dashboard-section${(open) ? ' open' : ''}`}>
      <h2 className='section-title' onClick={() => setOpen(!open)}>
        <img className='arrow' src='/images/icons/down-arrow.png' />
        {settings.title}
      </h2>

      <div className={`section-content content-${settings.contentType}`}>
        {data &&
          settings.contentType == 'boxes' &&
          settings.fields.map(f => {
            return (
              <div key={f.property} className='item-wrapper'>
                <div className='item'>
                  <div className='background'>
                    <img src={f.icon} />
                  </div>
                  <h3 className='title'>{f.title}</h3>
                  <span className='value'>
                    {data?.find(d => d.propertyName == f.property)
                      ?.propertyValue || '-'}
                  </span>
                </div>
              </div>
            )
          })}
        {data &&
          settings.contentType == 'labels' &&
          data?.map((d, idx) => {
            return (
              <div key={idx} className='item-wrapper'>
                <div className='item'>
                  <div className='background'>
                    <img src={settings.icon} />
                  </div>
                  <div className='keywords-container'>
                    <h3 className='title'>{d.personName}</h3>
                    <span className='description'>{d.description}</span>
                  </div>
                <div className='value-container'>
                  {d.age}
                </div>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default Dashboard
